import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';

import { Button } from '@eb/eds-button';

import './BBoxSearchButton.scss';

export default class BBoxSearchButton extends React.PureComponent {
    static propTypes = {
        style: PropTypes.shape({
            bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            marginTop: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            transform: PropTypes.string,
        }).isRequired,
        onClick: PropTypes.func.isRequired,
    };

    render() {
        const { style, onClick } = this.props;

        return (
            <div
                style={style}
                className="search-map__bbox-search-btn eds-align--center"
            >
                <Button style="neutral" onClick={onClick}>
                    {gettext('Search this area')}
                </Button>
            </div>
        );
    }
}
